import React from "react"

import {
    Grid,
    Stack,
} from "@mui/material"

import {
    MatesSelect,
    MatesSwitch,
    MatesTextField,
    withUseFormHook,
} from "@sinossi/mates-react-library"

import { UseFormReturn } from "react-hook-form"
import { Trans } from "@lingui/macro"

import {
    AssetType,
    ContractType,
    PositionType,
} from "models"
import { AdvancedSearchbar } from "components/advanced-searchbar"

import ProposalsAdvancedSearchSchema, { ProposalsAdvancedSearchForm } from "./form"

interface ProposalsAdvancedSearchProps extends UseFormReturn
{
}
class ProposalsAdvancedSearch extends React.Component<ProposalsAdvancedSearchProps, {}>
{

    render()
    {
        return (
            <AdvancedSearchbar
                {...this.props}
                searchFieldName="Proposte"
                searchFieldPlaceholder="Ricerca Proposte"
                onSearch={()=>{}}> {/* FIXME */}
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <MatesSelect
                            name="position"
                            label="Posizione"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(PositionType).map(positionKey =>
                                <option value={positionKey}>
                                    <Trans id={`enums.asset-position.${positionKey}`}>
                                    </Trans>
                                </option>
                            )}
                        </MatesSelect>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MatesSelect
                            name="assetType"
                            label="Tipo"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(AssetType)
                                .map(type =>
                                    <option value={type}>
                                        <Trans id={`enums.asset-types.${type}`}>
                                        </Trans>
                                    </option>
                                )
                            }
                        </MatesSelect>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <MatesTextField
                            name="shopWindows"
                            label="Numero di vetrine"
                            variant="outlined"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MatesSelect
                            name="contractType"
                            label="Tipo di contratto"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(ContractType).map(typeKey =>
                                <option value={typeKey}>
                                    <Trans id={`enums.contract-type.${typeKey}`}>
                                    </Trans>
                                </option>
                            )}
                        </MatesSelect>
                    </Grid>

                    <Grid item xs={12} md={6}>
                            <MatesTextField
                                name="minPrice"
                                label="Prezzo minimo"
                                variant="outlined"
                                control={this.props.control}
                                trigger={this.props.trigger}
                                formState={this.props.formState} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                            <MatesTextField
                                name="maxPrice"
                                label="Prezzo massimo"
                                variant="outlined"
                                control={this.props.control}
                                trigger={this.props.trigger}
                                formState={this.props.formState} />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Stack direction="row" justifyContent="center" spacing={5}>
                            <MatesSwitch
                                name="divisible"
                                label="Divisibile"
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger} />
                            <MatesSwitch
                                name="airConditioning"
                                label="Aria condizionata"
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger} />
                            <MatesSwitch
                                name="parkingSlots"
                                label="Parcheggi"
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger} />
                        </Stack>
                    </Grid>
                </Grid>
            </AdvancedSearchbar>
        )
    }
}

export default withUseFormHook<{}>(
    ProposalsAdvancedSearch,
    ProposalsAdvancedSearchSchema,
    new ProposalsAdvancedSearchForm(),
)
